import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class MultiTranslateLoader implements TranslateLoader {
  private http = inject(HttpClient);

  getTranslation(lang: string): Observable<TranslationObject> {
    return forkJoin([
      this.http.get<TranslationObject>(`./i18n/${lang}.json`),
      this.http.get<TranslationObject>(`./i18n/common/${lang}.json`).pipe(
        catchError(() => of({} as TranslationObject))
      ),
    ]).pipe(
      map(([app, common]) => this.deepMerge(app, common) as TranslationObject)
    );
  }

  private deepMerge(target: object, source: object): object {
    const result = { ...target };
    for (const key of Object.keys(source)) {
      const src = (source as Record<string, unknown>)[key];
      const tgt = (result as Record<string, unknown>)[key];
      if (src && typeof src === 'object' && !Array.isArray(src) &&
          tgt && typeof tgt === 'object' && !Array.isArray(tgt)) {
        (result as Record<string, unknown>)[key] = this.deepMerge(tgt as object, src as object);
      } else {
        (result as Record<string, unknown>)[key] = src;
      }
    }
    return result;
  }
}
